// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_3MDPDPpSXVYF5v6kj7p6bo","icon":"_2A4bdtdvO9MyU76YM5UTnA","active":"_3yuCXrhl6i_5PxHrcAMWti"};